import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API, timeout: 20000 });

export async function joinWaitlist({ email, accountType, source, honeypot }) {
  const { data } = await client.post("/waitlist", {
    email,
    account_type: accountType,
    source: source || "get-started",
    company_website: honeypot || "",
  });
  return data;
}

export async function submitAgencyLead(payload) {
  const { data } = await client.post("/agency-lead", {
    name: payload.name,
    email: payload.email,
    firm: payload.firm,
    num_clients: payload.numClients,
    message: payload.message || "",
    company_website: payload.honeypot || "",
  });
  return data;
}

export async function submitReminder({ email, honeypot }) {
  const { data } = await client.post("/reminder", {
    email,
    company_website: honeypot || "",
  });
  return data;
}

export default client;
